import React, {useState, Component} from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { FaFolder } from 'react-icons/fa';
import { Spinner } from 'components'
import Dropzone from './Dropzone';

import * as actionCreators from 'store/actions';
import classes from './FileInput.module.css';

class FileInput extends Component {
    // Implement system to allow rules on restricting the file uploaded
    constructor(props){
        super(props);
        this.fileUploadRules = this.props.fileUploadRules || {
            fileTypes: ['image'],
            sizeLimit: 4000000,
        };

        this.state = {
            file: null,
            spinner: false,
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps['url']){
            this.props.onSubmit(nextProps['url'])
            this.props.uploadReset()
        }
        return true
    }

    fileValidation = (file, rules) => {
        let valid = true;
        let error = null;
        const fileType = file ? file.type.split('/')[0] : null;
        const fileSize = file ? file.size : null;
        if(Object.keys(rules).length > 0){
            for (const [ruleName, ruleDef] of Object.entries(rules)) {
                if(ruleName === 'fileTypes'){
                    if(!ruleDef.includes(fileType)){
                        valid = false;
                        error = 'Invalid file type';
                    }
                } else if (ruleName  === 'sizeLimit'){
                    if(fileSize > ruleDef){
                        valid = false;
                        error = 'File too large';
                    }
                }
            }
        }
        const result = {valid: valid, error: error};
        return result
    }

    uploadHandler = (event) => {
        const file = event.target.files[0];
        const fileType = file ? file.type.split('/')[0] : null;
        const fileValidation = this.fileValidation(file, this.fileUploadRules);
        this.setState({spinner: true}, () => {
            if(fileValidation.valid){
                this.props.uploadImg(this.props.user, file)
            } else {
                this.setState({
                    error: fileValidation.error,
                    spinner: false
                })
            }
        })
    }

    dropHandler = (item, monitor) => {
        if(monitor){
            const files = monitor.getItem().files;
            if(files.length == 1){
                const file = files[0];
                const fileType = file ? file.type.split('/')[0] : null;
                const fileValidation = this.fileValidation(file, this.fileUploadRules);

                if(fileValidation.valid){
                    if(this.props.uploadHandler){
                        this.props.uploadHandler(file);
                    } else {
                        this.props.uploadFile(this.props.uid, file, fileType)
                    }
                } else {
                    this.props.storageError(fileValidation.error);
                }

            } else if (files.length > 1){
                this.props.storageError('Multiple files not allowed')
            } 
        }
    }

    render(){
        let error = null;

        return(
            <Dropzone onDrop={this.dropHandler}>
                <div className={classes.Dropbox}>
                    <label for="file-input">
                        <div className={classes.Container}>
                            <FaFolder className={classes.DropboxIcon}/>
                            {this.props.filename ? <div className={classes.Filename}>{this.props.filename}</div> : null}
                            {this.state.spinner && !this.props.url && !this.props.error? <Spinner/> : null}
                            <div className={classes.BrowseButton}>Choose file</div>
                        </div>
                    </label>
                    <input type="file" id="file-input" onChange={this.uploadHandler} style={{display: 'none'}}/>
                    <div className={classes.Title}>{this.props.placeholder}</div>
                    <div className={classes.Subtitle}>{this.state.error || this.props.error}</div>
                    {this.props.error ? <div className={classes.Error}>{this.props.error}</div> : null}
                </div>
            </Dropzone>
            
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        url: state.content.url,
        error: state.content.error,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        uploadImg: (uid,file) => dispatch(actionCreators.uploadImg(uid,file)),
        uploadReset: () => dispatch(actionCreators.uploadReset())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(FileInput);